import './diamondsGroup.css';
import React, { useContext } from 'react';
import DiamondImg from 'assets/diamond_icon.png';
import { GridList, GridListTile } from '@material-ui/core';
import RoomProvider from 'components/Provider/RoomProvider';
import gfGroupTypes from 'others/game/gfGroupTypes';

function DiamondItem({ key, selected, sCount, onClick, isGodFather }){
    var newValue = selected ? sCount-1 : sCount+1;
    newValue = newValue > 5 && isGodFather ? 5 : newValue;
    const data = newValue > 0 || isGodFather ? gfGroupTypes.diamond(newValue, isGodFather) : null;
    
    return (
        <GridListTile 
            key={key} 
            cols={1} 
            onClick={()=>onClick(data)} 
            className={`damond_item ${selected && 'selected'}`}
        >
            <img src={DiamondImg} alt='Diamant' style={{height: 64 }} />
        </GridListTile>
    )
}

function DiamondsGroup({ selectedCount, onDiamondClick }) {
    const { room } = useContext(RoomProvider);

    var diamondsItems = [];
    for (let i = 0; i < room.gfBox?.diamondCount; i++) {
        diamondsItems.push(<DiamondItem 
                                key={`diamond-${i}`} 
                                selected={i < selectedCount}
                                sCount={selectedCount ? selectedCount : 0}
                                onClick={room.status == 'Playing' ? onDiamondClick : ()=>{}} 
                                isGodFather={room.localPlayer?.role?.name == 'GodFather'}
                            />)        
    }

    return (
        <div id='diamondsGroup_container' className="diamondGroup">
            <p className='godfatherbox_itemCounter'>Il reste {room.gfBox?.diamondCount} diamant(s)</p>
            <GridList cellHeight={64} cols={2}>
                { diamondsItems.map(item=>item) }
            </GridList>
        </div>
    );
}

export default DiamondsGroup;